export enum InhalerTypes {
  Reliever = 'reliever',
  Maintenance = 'maintenance',
}

export type InhalerProduct = {
  patientId: string
  productAigNum: string
  productName: string
  productType: InhalerTypes
  productUid: string
}

export type InhalerCompliance = {
  patientId: string
  productType: InhalerTypes
  compliancePerc: number
  uncontrolledDays: number
  controlledDays: number
}

export type DataPoint = {
  timestamp: number
  value: number
}

export type InhalerUsage = {
  patientId?: string
  uid?: string
  name?: string
  type?: InhalerTypes
  aigNum?: string
  serialNumber?: string
  dataPoints: DataPoint[]
}

export type ShiftAndRoundReportMetricDetails = {
  label: string | null
  value: string | null
  unit: string | null
  change: {
    value: number | null
    good: boolean
  } | null
}
